module.exports = __webpack_public_path__ + "static/shears-66c4a9615849f0232fec2878fecd5e2d.jpg";